import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { ModalService } from '@common/components/modal/modal.service';
import { LanguageSettings } from '@common/services/language-settings';
import { NomWebServicesJson } from '@common/services/nom-web-services-json';
import { AppService } from '@suite/app.service';
import { UploaderOptions, UploadFile, UploadInput, UploadOutput, UploadStatus } from 'ngx-uploader';
import { Subject } from 'rxjs';

import { AvatarBaseDirective } from './avatar-base';

@Component({
    selector: 'st-avatar[upload]',
    templateUrl: './avatar-upload.html',
    styleUrls: ['./avatar-upload.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'st-avatar-upload' },
})
export class AvatarComponent extends EnpsComponent implements OnInit, OnDestroy {
    @Input() userId: string;
    options: UploaderOptions;
    dragOver: boolean;
    private _imageUrl: string = '';

    get imageUrl(): string {
        if (this._imageUrl === '') {
            this._imageUrl = this.appService.nomWebServicesJson.getAvatarImageUrl(this.userId);
        }
        return this._imageUrl;
    }

    public set imageUrl(value: string) {
        this._imageUrl = value;
    }

    files: UploadFile[];
    uploadInput: EventEmitter<UploadInput>;
    @Input() editAvatar: Subject<Event>;
    @ViewChild('file') input: ElementRef<HTMLInputElement>;

    constructor(
        public appService: AppService,
        public languageSettings: LanguageSettings,
        public nomWebServicesJson: NomWebServicesJson,
        public modalService: ModalService
    ) {
        super();
        this.files = [];
        this.uploadInput = new EventEmitter<UploadInput>();
    }

    async ngOnInit(): Promise<void> {
        this.editAvatar.subscribe(() => {
            this.openFile();
        });
    }

    openFile(): void {
        this.input.nativeElement.click();
    }

    onUploadOutput(output: UploadOutput): void {
        if (output.type === 'allAddedToQueue') {
            const event: UploadInput = {
                type: 'uploadAll',
                url: this.appService.nomWebServicesJson.getUploadEndPoint(),
                method: 'POST',
                data: {
                    userId: this.userId,
                    AvatarImage: this.files[0].nativeFile,
                },
                headers: {
                    'X-ENPS-TOKEN': this.nomWebServicesJson.NomTokenId,
                },
            };
            this.uploadInput.emit(event);
        } else if (output.type === 'done') {
            if (output.file.responseStatus > 400) {
                this.modalService.openAlert('Warning', output.file.response);
            }
            if (output.file.responseStatus === 200) {
                this.imageUrl = this.appService.nomWebServicesJson.getAvatarImageUrl(this.userId);
                delete AvatarBaseDirective.avatarErrorsByUserId[this.userId];
            }
        } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
            this.files[0] = output.file;
        } else if (output.type === 'cancelled' || output.type === 'removed') {
            this.files = this.files.filter((file: UploadFile) => file !== output.file);
        } else if (output.type === 'dragOver') {
            this.dragOver = true;
        } else if (output.type === 'dragOut') {
            this.dragOver = false;
        } else if (output.type === 'drop') {
            this.dragOver = false;
        }
        this.files = this.files.filter(file => file.progress.status !== UploadStatus.Done);
    }

    ngOnDestroy(): void {
        this.editAvatar.complete();
    }
}
